/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountDetailsResponse {
    getFixupPrototypeFunction() { return CloudAccountDetailsResponse.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountDetailsResponse>): CloudAccountDetailsResponse {
        let obj = Object.assign(new CloudAccountDetailsResponse(), model);
        CloudAccountDetailsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountDetailsResponse>): CloudAccountDetailsResponse {
        if (!model) return null;
        return CloudAccountDetailsResponse.newInstance(<CloudAccountDetailsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountDetailsResponse) {
        if (!obj) return;

        models.CloudAccountDetailsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountDetailsResponse): boolean {
        Object.setPrototypeOf(obj, CloudAccountDetailsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Displays the cloud associated with the template, for example, AWS, Azure etc
     */
    cloud: string;

    /**
     * Unique Identifier of the cloud account onboarded in the on boarding section
     */
    cloud_account_id: string;

    /**
     * The region of the cloud account where it needs to be executed. Mandatory for AWS
     */
    region: string;

    /**
     * Resource group for which you need to execute the template for. Mandatory for Azure
     */
    resourcegroup: string;

    /**
     * Location under which you need to execute the template for. Mandatory for Azure
     */
    location: string;

}
